import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Locale } from 'src/environments/language.config';

@Pipe({
  name: 'localizedDate',
  pure: false,
})
export class LocalizedDatePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(date: any, pattern: string = 'mediumDate', timezone?: string): any {
    const currentLang = this.translate.currentLang() || Locale.DE;

    if (date === 'TODAY' || date === 'YESTERDAY') {
      return date;
    }
    const formats: any = {
      [Locale.DE]: {
        longDate: 'dd. MMMM yyyy',
        shortTime: 'H:mm',
        startDay: 'dd.',
        endDay: 'dd. MMMM yyyy',
        startDayAndMonth: 'dd. MMMM',
        endDayAndMonth: 'dd. MMMM yyyy',
        yearOnly: 'yyyy',
        monthAndYear: 'MM yyyy',
        precise: 'dd. MMMM yyyy, HH:mm',
      },
      default: {
        longDate: 'MMMM dd, yyyy',
        shortTime: 'h:mm a',
        startDay: 'MMMM dd',
        startDayAndMonth: 'MMMM dd',
        endDay: 'dd, yyyy',
        endDayAndMonth: 'MMMM dd, yyyy',
        yearOnly: 'yyyy',
        monthAndYear: 'MM yyyy',
        precise: 'MMMM dd, yyyy, h:mm aaa',
      },
    };

    pattern = (formats[currentLang] || formats.default)[pattern] || pattern;
    return new DatePipe(currentLang).transform(date, pattern, timezone);
  }
}
